export default __webpack_public_path__ + "static/media/mockup@3x.a9c3e041.png";